<template>
  <div class="f-image-card-uploader">
    <Upload
      :class="{ 'is-limit': files.length >= limit }"
      list-type="picture-card"
      :action="url"
      :file-list="files"
      :limit="limit"
      :before-upload="beforeUpload"
      :on-success="handleSuccess"
      :on-exceed="handleExceed"
      :on-preview="handlePreview"
      :on-remove="handleRemove"
      :on-error="handleError"
      :aimPath="aimPath"
    >
      <i class="el-icon-plus" />
      <span
        v-show="showLimit && limit !== 1"
        class="num-tips"
      >{{ uploadedFiles.length }} / {{ limit }}</span>
    </Upload>
    <el-image v-show="false" ref="previewImageId" :src="previewImageSrc" :preview-src-list="previewImageUrl" />
  </div>
</template>

<script>
export default {
  name: "FImageCardUploader",
  components: {
    Upload: () => import("../FUpload/index"),
    FImage: () => import("../FImage"),
  },
  props: {
    // 上传地址
    url: {
      type: String,
      default: "",
    },
    // 传入的文件列表
    files: {
      type: Array,
      default: function () {
        return [];
      },
    },
    // 最大允许上传个数
    limit: {
      type: Number,
      default: 5,
    },
    // 缩略图显示宽度
    width: {
      type: String,
      default: "80px",
    },
    // 是否显示数量限制
    showLimit: {
      type: Boolean,
      default: true,
    },
    aimPath: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      previewImageId:
        "preview-" + +new Date() + (Math.random() * 1000).toFixed(0),
      previewImageUrl: [],
      previewImageSrc: "",
      uploadedFiles: this.files,
    };
  },
  computed: {},
  methods: {
    // 格式化文件数组，抛出change事件
    emitChange() {
      const result = [];
      this.uploadedFiles.forEach((item) => {
        if (item.id) {
          result.push({
            id: item.id,
            url: item.url,
          });
        } else if (item.response) {
          result.push({
            id: item.response.data.id,
            url: item.response.data.url,
          });
        }
      });
      this.$emit("change", result);
    },
    handlePreview(file) {
      const urls = this.files.map(item => item.url);
      this.previewImageSrc = file.url;
      this.previewImageUrl = urls;
      this.$nextTick(() => {
        this.$refs['previewImageId'].clickHandler();
      })
    },
    handleRemove(file, fileList) {
      // 禁止远程删除文件
      this.uploadedFiles = fileList;
      this.emitChange(fileList);
    },
    handleExceed() {
      this.$message.error(`最多上传 ${this.limit} 张图片！`);
    },
    beforeUpload(file) {
      // file.name =
      const formatArr = ["image/jpeg", "image/png"];
      if (formatArr.indexOf(file.type) === -1) {
        this.$message.error("上传图片格式只支持 jpg、 png！");
        return false;
      }
      if (file.size > 2 * 1024 * 1024) {
        this.$message.error("上传图片大小不能超过 2M！");
        return false;
      }
      return true;
    },
    handleSuccess(res, file, fileList) {
      this.uploadedFiles = fileList;

      if (!res.errno) {
        this.emitChange(fileList);
      }
    },
    handleError(err) {
      this.$message.error(err);
    },
  },
};
</script>

<style lang="scss" slot-scoped>
.f-image-card-uploader {
  .el-upload-list--picture-card .el-upload-list__item {
    width: 80px;
    height: 80px;
    .el-upload-list__item-status-label {
      background: #07c160;
    }
  }
  .el-upload {
    position: relative;
    width: 80px;
    height: 80px;
    line-height: 78px;
    padding-top: 5px;
    .num-tips {
      position: absolute;
      bottom: 4px;
      right: 4px;
      line-height: 1;
      color: #ccc;
      font-size: 13px;
    }
  }
  .is-limit .el-upload {
    display: none;
  }
}
</style>
